import {TrackableEntity} from './data/ChangeTrackable';
import { IDictionary } from './data/TrackingModule';
import { DBMappingInfo } from '../framework.core/data/DBMappingInfo';

export class ApDetail extends TrackableEntity {
    id: number = 0;
    apHdId: number = 0;
    stbName: string = '';
    stbId: number = 0;
    billingCode: string = '';
    description: string = '';
    rate: number = 0;
    qty: number = 0;
    amount: number = 0;
    amtDesc: string = '';
    cur: string = '';
    exRate: number = 0;
    lAmount: number = 0;
    olAmount: number = 0;
    useVat: number = 0;
    supplyPrice: number = 0;
    vatAmount: number = 0;
    agtAmount: number = 0;
    lAgtAmount: number = 0;
    agtCur: string = '';
    agtExRate: number = 0;
    vatGlNo: string = '';
    curAmount: number = 0;
    chgType: number = 0;
    chgTypeDesc: string = '';
    ps: number = 0;
    dBranch: string = '';
    entity: number = 0;
    entityName: string = '';
    subCode: string = '';
    agent: number = 0;
    agentName: string = '';
    posted: number = 0;
    savePosted: number = 0;
    iDate: string | null = null;
    entityTerms: number = 0;
    agentTerms: number = 0;
    errorMsg: string = '';
    isBillTypePartLock: boolean = false;
    isBillingCodePartLock: boolean = false;
    isDescriptionPartLock: boolean = false;
    isCurrencyPartLock: boolean = false;
    isRatePartLock: boolean = false;
    isQtyPartLock: boolean = false;
    isCurAmtPartLock: boolean = false;
    isAmountPartLock: boolean = false;
    isUseVatPartLock: boolean = false;
    isAgtCurPartLock: boolean = false;
    isAgtamtPartLock: boolean = false;
    isAgtNamePartLock: boolean = false;
    isPSPartLock: boolean = false;
    isKoreaVatLock: boolean = false;
    rowBackColor: string = '';
    isLock: boolean = false;
    isCreditLock: boolean = false;
    isGiveCreditLock: boolean = false;
    fieldType: number = 0;
    lock: number = 0;
    billCodeInactive: number = 0;
    toDeleteRowWhenCredit:boolean = false;
    seq: number = 0;
    // cloud

    crDbNo: string = '';
    additionallyAdded: boolean = false;
    lAmtDesc: string = '';
    //WH Description용
    refNo : string = '';

    //mskang - 241111 
    //BillingCode에서 Suffix가 없어지면서 suffix가 없게 보여주는 용도, 기존 billginCode는 저장시 사용되기때문에 Suffix그대로 저장하고 보여주기만 Suffix가 없게 
    billingCodeView: string = '';

    constructor(init?:Partial<ApDetail>) {
        super();
        this.key='id';
        Object.assign(this, init);
        this.noTrackProps.push('id', 'olAmount', 'chgTypeDesc', 'entityName', 'agentName', 'savePosted', 'iDate', 'entityTerms', 'agentTerms', 'errorMsg', 
        'isBillTypePartLock', 'isBillingCodePartLock', 'isDescriptionPartLock', 'isCurrencyPartLock', 'isRatePartLock', 'isQtyPartLock', 'isCurAmtPartLock', 'isAmountPartLock', 'isUseVatPartLock', 'isAgtCurPartLock', 'isAgtamtPartLock', 'isAgtNamePartLock', 'isPSPartLock',
            'isKoreaVatLock', 'rowBackColor', 'lock', 'lAmtDesc',
        'additionallyAdded','toDeleteRowWhenCredit','isLock','amtDesc','refNo');
        if(this.id === 0) this.id = this.GetNextId();
    }

    getDbMappings(arg?:any):IDictionary<DBMappingInfo> {
        return ApDetail.dicFieldMappings;
    }

    static dicFieldMappings:IDictionary<DBMappingInfo> = {
        'apHdId': new DBMappingInfo({ field: 'F_APHDID', table: 'T_APDETAIL' }),
        'billingCode': new DBMappingInfo({ field: 'F_BillingCode', table: 'T_APDETAIL' }),
        'description': new DBMappingInfo({ field: 'F_Description', table: 'T_APDETAIL' }),
        'cur': new DBMappingInfo({ field: 'f_cur', table: 'T_APDETAIL' }),
        'rate': new DBMappingInfo({ field: 'f_rate', table: 'T_APDETAIL' }),
        'qty': new DBMappingInfo({ field: 'f_qty', table: 'T_APDETAIL' }),
        'curAmount': new DBMappingInfo({ field: 'f_curamount', table: 'T_APDETAIL' }),
        'amount': new DBMappingInfo({ field: 'F_Amount', table: 'T_APDETAIL' }),
        'useVat': new DBMappingInfo({ field: 'f_usevat', table: 'T_APDETAIL' }),
        'chgType': new DBMappingInfo({ field: 'f_chgtype', table: 'T_APDETAIL' }),
        'vatAmount': new DBMappingInfo({ field: 'f_VatAmount', table: 'T_APDETAIL' }),
        'vatGlNo': new DBMappingInfo({ field: 'F_VATGLNO', table: 'T_APDETAIL' }),
        'lAmount': new DBMappingInfo({ field: 'F_LAmount', table: 'T_APDETAIL' }),
        'stbId': new DBMappingInfo({ field: 'F_STBID', table: 'T_APDETAIL' }),
        'stbName': new DBMappingInfo({ field: 'F_STBNAME', table: 'T_APDETAIL' }),
        'agtCur': new DBMappingInfo({ field: 'F_AGTCUR', table: 'T_APDETAIL' }),
        'agtAmount': new DBMappingInfo({ field: 'F_AGTAMOUNT', table: 'T_APDETAIL' }),
        'lAgtAmount': new DBMappingInfo({ field: 'F_LAGTAMOUNT', table: 'T_APDETAIL' }),
        'agtExRate': new DBMappingInfo({ field: 'F_AGTEXRATE', table: 'T_APDETAIL' }),
        'ps': new DBMappingInfo({ field: 'F_PS', table: 'T_APDETAIL' }),
        'exRate': new DBMappingInfo({ field: 'F_EXRATE', table: 'T_APDETAIL' }),
        'agent': new DBMappingInfo({ field: 'F_Agent', table: 'T_APDETAIL' }),
        'entity': new DBMappingInfo({ field: 'F_Entity', table: 'T_APDETAIL' }),
        'subCode': new DBMappingInfo({ field: 'F_SubCode', table: 'T_APDETAIL' }),
        'id': new DBMappingInfo({ field: 'F_Id', table: 'T_APDETAIL' }),
        'fieldType': new DBMappingInfo({ field: 'F_FieldType', table: 'T_APDETAIL' }),
        'seq': new DBMappingInfo({ field: 'F_Seq', table: 'T_APDETAIL' }),
    };
}
